import { ComponentSize } from '@eleventheye/asui';
import { ITeamDetails } from '@shared/types';
import TeamField, { TeamFields } from 'app/scenes/statsmanager/components/team/components/field/TeamField';
import TeamLogo from 'app/scenes/statsmanager/components/teamlogo/TeamLogo';
import { breakTeamAbrvID } from 'helpers/IdHelpers';
import React, { memo } from 'react';
import styles from './TeamInfoSection.module.scss';

type TeamInfoSectionProps = {
  teamDetails: ITeamDetails;
};

const conferenceText = 'Conference';
const divisionText = 'Division';
const stadiumText = 'Stadium';
const capacityText = 'Capacity';
const cityStateText = 'City / State';
const na = 'N/A';
const rivalriesText = 'Rivalries';

const TeamInfoSection: React.FC<TeamInfoSectionProps> = ({ teamDetails }) => {
  const conference = teamDetails?.teamConference || na;
  const division = teamDetails?.teamDivision || na;
  const stadium = teamDetails?.teamStadium || na;
  const capacity = teamDetails?.teamCapacity || na;
  const cityState = teamDetails ? `${teamDetails.teamCity}, ${teamDetails.teamState}` : na;
  const fieldType = teamDetails ? teamDetails.teamStadiumFieldType : na;
  const roofType = teamDetails ? (teamDetails?.teamStadiumHasRoof ? 'Dome / Roof' : 'Open, No Cover') : na;
  const rivalries = teamDetails ? (teamDetails.rivalries ?? []) : [];

  return (
    <div className={styles.TeamInfo}>
      <TeamFields>
        <TeamField labelMinWidth={50} text={conference} textLabel={conferenceText} />
        <TeamField text={division} textLabel={divisionText} />
      </TeamFields>
      <TeamFields>
        <TeamField labelMinWidth={50} text={stadium} textLabel={stadiumText} />
        <TeamField text={capacity} textLabel={capacityText} />
      </TeamFields>
      <TeamFields>
        <TeamField labelMinWidth={50} text={roofType} textLabel="Stadium Type" />
        <TeamField text={fieldType} textLabel="Field Type" />
      </TeamFields>
      <TeamFields>
        <TeamField labelMinWidth={50} text={cityState} textLabel={cityStateText} />
        <TeamField labelMinWidth={20} textLabel={rivalriesText}>
          <div className={styles.TeamRivals}>
            {rivalries.map((r) => (
              <TeamLogo
                key={breakTeamAbrvID(r).teamAbrv}
                teamName={breakTeamAbrvID(r).teamAbrv}
                iconType="v1"
                size={ComponentSize.Small}
              />
            ))}
          </div>
        </TeamField>
      </TeamFields>
    </div>
  );
};

export default memo(TeamInfoSection);
